/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyMobileDeviceHasMobileApp
 */
export interface ReadOnlyMobileDeviceHasMobileApp {
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMobileDeviceHasMobileApp
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyMobileDeviceHasMobileApp
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyMobileDeviceHasMobileApp
     */
    upgradedAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMobileDeviceHasMobileApp
     */
    mobileDevice: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMobileDeviceHasMobileApp
     */
    mobileApp: string;
}

export function ReadOnlyMobileDeviceHasMobileAppFromJSON(json: any): ReadOnlyMobileDeviceHasMobileApp {
    return ReadOnlyMobileDeviceHasMobileAppFromJSONTyped(json, false);
}

export function ReadOnlyMobileDeviceHasMobileAppFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyMobileDeviceHasMobileApp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'upgradedAt': !exists(json, 'upgraded_at') ? undefined : (json['upgraded_at'] === null ? null : new Date(json['upgraded_at'])),
        'mobileDevice': json['mobile_device'],
        'mobileApp': json['mobile_app'],
    };
}

export function ReadOnlyMobileDeviceHasMobileAppToJSON(value?: ReadOnlyMobileDeviceHasMobileApp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'upgraded_at': value.upgradedAt === undefined ? undefined : (value.upgradedAt === null ? null : value.upgradedAt.toISOString()),
        'mobile_device': value.mobileDevice,
        'mobile_app': value.mobileApp,
    };
}


